import { ChampionshipInfoForm } from 'modules/championship/ui/components/championship-form';
import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import { ChampionshipEncoded } from 'modules/championship/domain/interfaces/championship-encoded';
import React from 'react';
import CreateFormTabs from './tabs';

type Props = {
  onSubmit: (data: Partial<ChampionshipEncoded>) => any;
};

const ChampionshipCreateForm = (props: Props) => {
  const { info } = useOrganizer();

  if (!info) {
    return null;
  }

  return (
    <>
      <div className="w-full px-6 py-6">
        <CreateFormTabs />
      </div>
      <ChampionshipInfoForm tournamentId={info!.id} />
    </>
  );
};

export default ChampionshipCreateForm;
